import { render } from "./ProductsSegment.vue?vue&type=template&id=562d18fe"
import script from "./ProductsSegment.vue?vue&type=script&lang=js"
export * from "./ProductsSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__